export { PaginatorComponent } from './paginator.component'
